import http from "@util/http";
import { hr } from "@api/req";

/**
 * 年终奖
 */
export async function bonus(params) {
  return http.get(hr.GET_BONUS_LIST, params);
}

export async function queryBonusMyList(params) {
  return http.get(hr.GET_BONUS_MY, params);
}

export async function queryMyBonusCheckList(params) {
  return http.get(hr.GET_BONUS_CHECK, params);
}

export async function queryBonusOrgRecord(params) {
  return http.get(hr.GET_BONUS_RECORD_ORG, params);
}

export async function queryBonusInfo(params) {
  return http.get(hr.GET_BONUS_INFO, params);
}

export async function queryImportBonus(params) {
  return http.post(hr.BONUS_IMPORT, params);
}

export async function querySaveBonus(params) {
  return http.post(hr.BONUS_SAVE, params);
}

export async function queryDeleteBonus(params) {
  return http.get(hr.BONUS_DELETE, params);
}

export async function queryNextBonus(params) {
  return http.get(hr.BONUS_NEXT, params);
}

export async function queryReturnBonus(params) {
  return http.post(hr.BONUS_RETURN, params);
}

export async function queryCallbackBonus(params) {
  return http.get(hr.BONUS_CALLBACK, params);
}

export async function queryBonusWorkflow(params) {
  return http.get(hr.BONUS_WORKFLOW, params);
}

export async function queryBonusStaticComMonth(params) {
  return http.get(hr.BONUS_STATIC_C_M, params);
}

export async function queryBonusDetailList(params) {
  return http.get(hr.BONUS_DETAIL_LIST, params);
}

export async function queryBonusDetailInfo(params) {
  return http.get(hr.BONUS_DETAIL_INFO, params);
}

export async function querySendAllBonus(params) {
  return http.get(hr.BONUS_SEND_ALL, params);
}

export async function querySendBonus(params) {
  return http.get(hr.BONUS_SEND, params);
}

export async function queryBackAllBonus(params) {
  return http.get(hr.BONUS_BACK_ALL, params);
}

export async function queryBackBonus(params) {
  return http.get(hr.BONUS_BACK, params);
}

export async function queryDownloadBonusTemplate() {
  http.download(hr.DOWNLOAD_BONUS_TEMPLATE, {}, '年终奖导入模板.xlsx');
}



// WEBPACK FOOTER //
// ./src/api/hr/bonus.js